import { render } from "./DevelopmentEditorView.vue?vue&type=template&id=847abed4&scoped=true"
import script from "./DevelopmentEditorView.vue?vue&type=script&lang=js"
export * from "./DevelopmentEditorView.vue?vue&type=script&lang=js"

import "./DevelopmentEditorView.vue?vue&type=style&index=0&id=847abed4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-847abed4"]])

export default __exports__